export class CategoryType {

    readonly PLAN_NAME : string = "planname";
    readonly PLAN_SPONSOR : string = "plansponsor";
    readonly EIN : string = "ein";
    readonly PN : string = "pn";
    readonly ACK_ID: string = "ackid";
    readonly PLAN_YEAR: string = "planyear";
    readonly PLAN_CODE: string = "plancode";
    readonly ASSETS: string = "assetseoy";
    readonly PARTICIPANTS: string = "participantsboy";
    readonly EMPLOYER: string = "plantype";
    readonly BUSINESS: string = "businesscode";
    readonly BUSINESSCAT: string = "businesscodecat";
    readonly STATES: string = "state";
    readonly COUNTRIES: string = "countrycode";
    readonly FORM_YEAR: string = "formyear";
    readonly ZIPCODE: string = "zip";

}